import { Children, useState, useEffect } from "react";
import { Paper, Typography, Grid, Tooltip } from "@mui/material";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
import { getDate, getHours, getMinutes, getMonth } from "date-fns";
import sharedService from "../../../../../Services/SharedService";

// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import FullscreenIcon from '@mui/icons-material/Fullscreen';

import LineChart from "../../../../Components/Chart/Component/LineChart";
import BarChart from "../../../../Components/Chart/Component/BarChart";
import WaterLevelView from "../../../../Components/Chart/Component/WaterLevelView";
import MultiLineChart from "../../../../Components/Chart/Component/MultiLineChart";

import { calculateQS as CalculateFlowSpin } from "../../../../Components/Chart/Component/chart_data";
import { CalculateFlow as CalculateFlowDrain } from "../../../../Components/Interpolation/drain";
import image from "../../../../../Asset/water_proof2/daton1.png";
import { BuildChartData, adjustRAData, TYPE_CHART } from "../../../../Components/Chart/Component/chart_data";
import { ID_GROUPS } from "../../../../../Utils/const";
import { NAMED_COLORS } from "../../../../Components/App/Utils/CustomChart";

const Chart = (props) => {
    const [dataWaterLevelView, setDataWaterLevelView] = useState()
    const [charts, setCharts] = useState();
    const [slideIndex, setSlideIndex] = useState(+1);

    const checkKG = window.localStorage.getItem('group_id') === ID_GROUPS.KG

    useEffect(async () => {
        let z; // Ztl
        let dr; // độ mở cống
        let q; // lưu lượng
        const groupRecord = await (await sharedService.listRecordBoxGroup()).data;

        if (checkKG) {
            // Lấy dữ liệu từ T3 (WU589RSL) để mapping cho các boxes khác
            const t3Group = groupRecord.find(g => g.box.id === "WU589RSL");
            
            if (t3Group && t3Group.records.length > 0) {
                 groupRecord.map(g => {
                    const boxId = g.box.id;
                    
                    // T5 (KDD0SN4G): lấy water_proof_5-8
                    if (boxId === "KDD0SN4G") {
                        g.records = t3Group.records.map(d => ({
                            WP1: d.water_proof_5,
                            WP2: d.water_proof_6,
                            WP3: d.water_proof_7,
                            WP4: d.water_proof_8,
                            t: d.t,
                            n: d.n
                        }));
                        g.count = t3Group.count;
                    }
                    // T6 (D6QKHC5Y): lấy water_proof_9-12
                    else if (boxId === "D6QKHC5Y") {
                        g.records = t3Group.records.map(d => ({
                            WP1: d.water_proof_9,
                            WP2: d.water_proof_10,
                            WP3: d.water_proof_11,
                            WP4: d.water_proof_12,
                            t: d.t,
                            n: d.n
                        }));
                        g.count = t3Group.count;
                    }
                    // T1 (SPMXV9A0): lấy water_proof_13-16
                    else if (boxId === "SPMXV9A0") {
                        g.records = t3Group.records.map(d => ({
                            WP1: d.water_proof_13,
                            WP2: d.water_proof_14,
                            WP3: d.water_proof_15,
                            WP4: d.water_proof_16,
                            t: d.t,
                            n: d.n
                        }));
                        g.count = t3Group.count;
                    }
                    // T2 (YKEZCC6N): lấy water_proof_17-20
                    else if (boxId === "YKEZCC6N") {
                        g.records = t3Group.records.map(d => ({
                            WP1: d.water_proof_17,
                            WP2: d.water_proof_18,
                            WP3: d.water_proof_19,
                            WP4: d.water_proof_20,
                            t: d.t,
                            n: d.n
                        }));
                        g.count = t3Group.count;
                    }
                     // T4 (QYOV7RB9): lấy water_proof_17-20
                    else if (boxId === "QYOV7RB9") {
                        g.records = t3Group.records.map(d => ({
                            WP1: d.water_proof_17 - 2,
                            WP2: d.water_proof_18 - 1,
                            WP3: d.water_proof_19 - 1,
                            WP4: d.water_proof_20 - 2,
                            t: d.t,
                            n: d.n
                        }));
                        g.count = t3Group.count;
                    }
                    // Mở tràn (3KVAXM37): lấy DR1-3
                    else if (boxId === "3KVAXM37") {
                        g.records = t3Group.records.map(d => ({
                            DR1: d.DR1 || 0,
                            DR2: d.DR2 || 0,
                            DR3: d.DR3 || 0,
                            t: d.t,
                            n: d.n
                        }));
                        g.count = t3Group.count;
                    }
                    // Mực nước hồ (B5R6ZA0U): lấy WAU, RA
                    else if (boxId === "B5R6ZA0U") {
                        g.records = t3Group.records.map(d => ({
                            WAU: +d.WAU < 200 ? d.WAU : 45,
                            RA: !d.RA || d.RA > 1000 ? 0 : d.RA,
                            t: d.t,
                            n: d.n
                        }));
                        g.count = t3Group.count;
                    }

                    return g;
                });
            }
            
            // Filter records để lấy dữ liệu mỗi 30 phút hoặc hourly
            groupRecord.forEach(g => {
                g.records = g.records.filter(r => getMinutes(r.t * 1000) === 0 || getMinutes(r.t * 1000) === 30);
            }); 
        }
        // Thông số hiện tại
        groupRecord.forEach(g => {
            if (g.count === 0) return;
            if (g.box.id === 'WK34ZRT9') {
                const record = g.records[0]
                z = record?.WAU
                q = CalculateFlowSpin(record, z)
            }
            if (g.box.id === 'R8ZLNSJX') {
                dr = g.records[0]?.DR1 / 1000
            }

        })
        const dataWLV = { z, q, q_of: CalculateFlowDrain(dr, z) || 0 }
        setDataWaterLevelView(dataWLV)
        //////
        const result = groupRecord.map(g => {
            const chart = BuildChartData(g.records, g.box, z)
            return chart
        })

        const docs = adjustRAData(result.filter(r => r))
        if (checkKG) {
            // Thêm đường hiển thị mực nước thượng lưu vào 4 biểu đồ khác dc yêu cầu
            const dataWAU = docs.find(d => d.metric === 'WA' && d?.datasets[0]?.code === 'WAU')
            
            if (dataWAU) {
                dataWAU.datasets[0].borderColor = NAMED_COLORS[5]
                dataWAU.datasets[0].backgroundColor = NAMED_COLORS[5]
                docs.map(d => {
                    if (['SPMXV9A0', 'WU589RSL', 'YKEZCC6N', 'QYOV7RB9'].includes(d.box_id)) {
                        d.datasets.push(dataWAU.datasets[0])
                    }
                })
            }
            setCharts(docs.filter(d => d.type))
        }
        else setCharts(docs)
    }, [])

    const handleSlide = (e) => {
        const { activeIndex } = e;
        setSlideIndex(activeIndex + 1);
    }


    const handleFullScreen = () => {
        const img = document.getElementById("chart-slide");
        img.requestFullscreen();
    }

    return (
        <>
            <Paper
                id="chart-slide"
                className="Chart-Right"
                elevation={8}
                sx={{
                    boxShadow: 'none',
                    border: '1.5px solid',
                    borderRight: 'none',
                    color: ' #0000001f',
                    borderRadius: '5px'
                }}
            >
                <div className="middle top">
                    <Grid container>
                        <Grid item xs={12} className="middle">
                            <Typography
                                className="title"
                                sx={{ fontSize: { xs: '16px', lg: '18px' } }}
                            >
                                Dữ liệu biểu đồ
                                <Tooltip title="Toàn màn hình" className="btn-fs">
                                    <FullscreenIcon className="fontsz-30" onClick={handleFullScreen} />
                                </Tooltip>
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
                <div className="content">
                    <Swiper
                        className="content-carousel"
                        modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                        spaceBetween={50}
                        slidesPerView={1}
                        // navigation
                        pagination={{ clickable: true }}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }}
                        // scrollbar={{ draggable: true }}
                        // onSwiper={(swiper) => console.log(swiper)}
                        onSlideChange={handleSlide}
                    >
                        {charts && Children.toArray(charts.map(t => {
                            if (t.metric === 'WAU') return <SwiperSlide onDoubleClick={handleFullScreen} className='pointer'><WaterLevelView box_id={t.box_id} data={dataWaterLevelView} /></SwiperSlide>
                            if (t.type === 'line') return <SwiperSlide onDoubleClick={handleFullScreen} className='pointer'><LineChart max={checkKG && t.metric === 'WA' ? 60 : 60} data={t} /></SwiperSlide>
                            if (t.type === 'multiLine') return <SwiperSlide onDoubleClick={handleFullScreen} className='pointer'><MultiLineChart data={t} /></SwiperSlide>
                            if (t.type === 'bar') return <SwiperSlide onDoubleClick={handleFullScreen} className='pointer'><BarChart data={t} /></SwiperSlide>
                            else return <SwiperSlide onDoubleClick={handleFullScreen} className='pointer'><img src={image} className="width-percent-100" alt="" /></SwiperSlide>
                        }))}
                    </Swiper>
                </div>
                <div className="bot">
                    <Typography className="fontsz-14 end pr-17">
                        <>Hiển thị {slideIndex}/ <b>{charts?.length}</b> biểu đồ</>
                    </Typography>
                </div>
            </Paper>
        </>
    )
}

export default Chart;